/** @format */

import React from 'react';

import { Row, Col, notification } from 'antd';

import Images from '../../../../../../components/Commons/Images';

import { ENV_IMG } from '../../../../../../components/Commons/Hooks/Variables/Enviroment';

import { GlobalConsumer } from '../../../../../../components/Commons/Context/Global';

import './style.scss';

export function NotificationAddressBuyNow() {
	const { setModalAddress } = GlobalConsumer();

	const handleOpenModalAddress = () => {
		notification.close(3);
		setModalAddress(true);
	};

	const handleNotificationAddressBuyNow = () => {
		notification.open({
			duration: 0,
			className: 'ph-detail-product-address-info-notification-main-container',
			description: (
				<>
					<div className="ph-detail-product-address-info-notification-main-title-container">
						<h1 className="ph-detail-product-address-info-notification-main-title">Información sobre tu compra:</h1>
					</div>
					<Row className="ph-detail-product-address-info-notification-description-main-container">
						<Col span={6} className="ph-detail-product-address-info-notification-image-main-container">
							<Images
								classContent={'ph-detail-product-address-info-notification-image-container'}
								classImage={'ph-detail-product-address-info-notification-image'}
								webp={`${ENV_IMG}/react-notification/warning.webp`}
								jp2={`${ENV_IMG}/react-notification/warning.jp2`}
								jxr={`${ENV_IMG}/react-notification/warning.jxr`}
								default={`${ENV_IMG}/react-notification/warning.png`}
								alt={'Notification'}
								title={'Notification'}
							/>
						</Col>
						<Col span={18}>
							<div className="ph-detail-product-address-info-notification-pharmacy">
								<p className="ph-detail-product-address-info-notification-pharmacy-title">¡Importante!</p>
							</div>
							<div className="ph-detail-product-address-info-notification-price-container">
								<p className="ph-detail-product-address-info-notification-price-title">Es necesario que selecciones tu ubicación y así brindarte una mejor experiencia.</p>
							</div>
						</Col>
					</Row>
					<hr className="ph-detail-product-address-info-notification-separator" />
					<Row>
						<Col span={24} className="ph-detail-product-address-info-notification-total-container">
							<Images
								classContent={'ph-detail-product-address-info-notification-total-image-container'}
								classImage={'ph-detail-product-address-info-notification-total-image'}
								webp={`${ENV_IMG}/react-header/pharol-location.webp`}
								jp2={`${ENV_IMG}/react-header/pharol-location.jp2`}
								jxr={`${ENV_IMG}/react-header/pharol-location.jxr`}
								default={`${ENV_IMG}/react-header/pharol-location.png`}
								alt={'item.name'}
								title={'item.name'}
							/>
							<p className="ph-detail-product-address-info-notification-total-title">Abrir Selector de Direcciones:</p>
							<span className="ph-detail-product-address-info-notification-total-subtitle" onClick={() => handleOpenModalAddress(true)}>
								Click Aquí
							</span>
						</Col>
					</Row>
				</>
			),
			key: 3,
			placement: 'topRight',
		});
	};

	return {
		handleNotificationAddressBuyNow,
	};
}
